/**
 * Quantity selector component
 *
 * @module quantity-selector
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "quantity-selector";

if (!customElements.get(customElements.component)) {
  class quantitySelector extends HTMLElement {
    /**
     * Quantity selector web component
     *
     * @constructor
     */
    constructor() {
      super();

      this.classList.add("quantity-selector");

      this.input = this.querySelector("input");

      this.valueElements =
        this.closest("form")?.querySelectorAll(".case-quantity--value") ?? [];

      this.caseQty =
        parseInt((this.dataset.caseQty ?? "")?.match(/\d+/g)?.join("")) ?? "";

      this.dataset.type =
        typeof this.dataset.type != "undefined" ? this.dataset.type : "product";

      this.render();
    }

    render() {
      this.renderInput();

      this.initEvents();

      this.updateCaseCount(this.input?.value);
    }

    updateCaseCount(value) {
      if (!this.valueElements.length) {
        console.error("Missing value element for case count");
        return;
      }

      if (Number.isNaN(+value) || Number.isNaN(+this.caseQty)) {
        console.error("Failed to update case count");
        this.valueElements.forEach((valueElement) => {
          valueElement.innerText = "";
        });
        return;
      }

      this.valueElements.forEach((valueElement) => {
        const totalUnits = this.caseQty * this.input.value;
        if (this.caseQty > 1) {
          valueElement.innerText = `${this.input.value} Case${this.input.value > 1 ? 's' : ''} | ${totalUnits} Units`;
        } else {
          valueElement.innerText = `${totalUnits} Unit${this.input.value > 1 ? 's' : ''}`;
        }
      });
    }

    renderInput() {
      if (!this.input) {
        let input = document.createElement("input");
        input.type = "number";
        input.min = 1;
        input.size = 4;
        input.autocomplete = "off";
        input.pattern = "[0-9]*";
        input.name = this.dataset.name ? this.dataset.name : "";
        input.id = this.dataset.id ? this.dataset.id : "";
        input.value = this.dataset.value ? parseInt(this.dataset.value) : 1;
        input.ariaLabel = this.dataset.label ? this.dataset.label : "Quantity";

        this.append(input);

        this.input = this.querySelector("input");
      }
    }

    initEvents() {
      this.querySelector('[data-action="decrease"]').addEventListener(
        "click",
        this.decrease.bind(this)
      );
      this.querySelector('[data-action="increase"]').addEventListener(
        "click",
        this.increase.bind(this)
      );

      this.input.addEventListener("input", () => {
        if (this.input.dataset.placement === 'cart') return;

        if (parseInt(this.input.value) < 1) {
          this.input.value = "1";
        }
      });

      this.input.addEventListener("change", this.quantityChanged.bind(this));

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-case-qty') {
            this.caseQty = parseInt(this.getAttribute('data-case-qty'));

            this.valueElements.forEach((valueElement) => {
              if (this.caseQty === 1) {
                valueElement.innerText = `${this.caseQty * this.input.value} Unit`;
              } else if (this.caseQty > 1) {
                valueElement.innerText = `${this.input.value} Case / ${
                  this.caseQty * this.input.value
                } Units`;
              }
            });
          }
        }
      });

      const config = {attributes: true};
      observer.observe(this, config);
    }

    decrease() {
      let value = parseInt(this.input.value);

      if (value > 0) {
        value--;

        this.input.value = value;

        let event = new CustomEvent("change", { detail: this.input });

        this.input.dispatchEvent(event);
      }
    }

    increase() {
      let value = parseInt(this.input.value);

      value++;

      this.input.value = value;

      let event = new CustomEvent("change", { detail: this.input });

      this.input.dispatchEvent(event);
    }

    quantityChanged(event) {
      const customEvent = new CustomEvent(
        `quantity-changed-${event.target.dataset.handle}`,
        {
          detail: { value: event.target.value },
          bubbles: true,
          composed: true,
        }
      );

      window.dispatchEvent(customEvent);

      this.updateCaseCount(event.target.value);
    }
  }

  customElements.define(customElements.component, quantitySelector);
}
